import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["click", "keydown"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { computed, getCurrentInstance, inject, useAttrs, useListeners } from 'vue';
import { KeyboardKey } from '@/shared/constants';
import { clickableProps, useClickable } from '@/shared/lib/composables/useClickable';
import Ripple from '@/shared/lib/directives/ripple';
var __default__ = {
  name: 'VListItem',
  inheritAttrs: false
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: _objectSpread(_objectSpread({}, clickableProps), {}, {
    dense: Boolean,
    inactive: Boolean,
    selectable: Boolean,
    tag: {
      type: String,
      default: 'div'
    },
    threeLine: Boolean,
    twoLine: Boolean
  }),
  emits: ['click', 'keydown'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var vRipple = Ripple;
    var instance = getCurrentInstance();
    var attrs = useAttrs();
    var listeners = useListeners();
    var isInList = inject('isInList', false);
    var _useClickable = useClickable(props),
      isClickable = _useClickable.isClickable,
      computedRipple = _useClickable.computedRipple;
    var rootTag = computed(function () {
      return props.inactive ? 'div' : props.tag;
    });
    var classes = computed(function () {
      return {
        'v-list-item': true,
        'v-list-item--dense': props.dense,
        'v-list-item--disabled': props.disabled,
        'v-list-item--link': isClickable.value && !props.inactive,
        'v-list-item--selectable': props.selectable,
        'v-list-item--three-line': props.threeLine,
        'v-list-item--two-line': props.twoLine
      };
    });
    var boundAttrs = computed(function () {
      var result = _objectSpread({
        'aria-disabled': props.disabled ? true : undefined,
        'tabindex': isClickable.value && !props.disabled ? 0 : -1
      }, attrs);
      var hasRole = Object.prototype.hasOwnProperty.call(attrs, 'role');
      if (!hasRole && isInList) {
        result.role = 'listitem';
      }
      return result;
    });
    var forwardedListeners = computed(function () {
      var click = listeners.click,
        keydown = listeners.keydown,
        rest = _objectWithoutProperties(listeners, _excluded);
      return rest;
    });
    function handleClick(event) {
      if (event.detail) {
        var _instance$proxy;
        var el = instance === null || instance === void 0 || (_instance$proxy = instance.proxy) === null || _instance$proxy === void 0 ? void 0 : _instance$proxy.$el;
        if (el instanceof HTMLElement) {
          el.blur();
        }
      }
      emit('click', event);
    }
    function handleKeydown(event) {
      if (event.key === KeyboardKey.Enter) {
        handleClick(event);
      }
      emit('keydown', event);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      vRipple: vRipple,
      instance: instance,
      attrs: attrs,
      listeners: listeners,
      isInList: isInList,
      isClickable: isClickable,
      computedRipple: computedRipple,
      rootTag: rootTag,
      classes: classes,
      boundAttrs: boundAttrs,
      forwardedListeners: forwardedListeners,
      handleClick: handleClick,
      handleKeydown: handleKeydown
    };
  }
}));